import { Component, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { AuthService } from 'src/app/_service/auth.service';
import { AuthConfigService } from 'src/app/_service/auth-config.service';
import { UserProfileComponent } from 'src/app/users/user-profile/user-profile.component';
import { MatDialog } from '@angular/material';
import { UserUpdatepasswordComponent } from 'src/app/users/user-updatepassword/user-updatepassword.component';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { Router } from '@angular/router';
import { LoginComponent } from 'src/app/login/login.component';

@Component({
  selector: 'app-sidenav-list',
  templateUrl: './sidenav-list.component.html',
  styleUrls: ['./sidenav-list.component.css']
})
export class SidenavListComponent implements OnInit {
  @Output() closeSidenav = new EventEmitter<void>();

  constructor(
    public authService: AuthService,
    public authConfigService: AuthConfigService,
    public dialog: MatDialog,
    public alertify: AlertifyService,
    private router: Router) { }

  ngOnInit() {
  }

  onClose() {
    this.closeSidenav.emit();
  }

  loggedIn() {
    return this.authService.loggedIn();
  }

  checkRoles() {
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'True') {
      return false;
    }
    if (this.authService.decodedToken.role === 'Regular') {
      return false;
    } else {
      return true;
    }
  }

  isInActive() {
    if (this.authService.decodedToken.role === 'InActive') {
      return true;
    } else {
      return false;
    }
  }

  showLogOutForGeneric() {
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'True') {
      return true;
    }
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'False') {
      return false;
    }
    if (this.authService.decodedToken.role === 'Super Admin' || this.authService.decodedToken.role === 'Site Admin') {
      return false;
    }
  }

  showSDSRequestLink() {
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'True') {
      return false;
    }
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'False') {
      return true;
    }
    if (this.authService.decodedToken.role === 'Super Admin' || this.authService.decodedToken.role === 'Site Admin') {
      return true;
    }
  }

  UserTypes() {
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'True') {
      return true;
    }
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'False') {
      return false;
    }
    if (this.authService.decodedToken.role === 'Super Admin' || this.authService.decodedToken.role === 'Site Admin') {
      return false;
    }
  }

  windowsLoggin() {
    return this.authService.windowsAuthentication();
  }

  /**
   * Checks if the current mode is Windows authentication
   */
  isWindowsAuthMode(): boolean {
    return this.authConfigService.isWindowsAuthMode();
  }

  /**
   * Checks if the current mode is credentials authentication
   */
  isCredentialsAuthMode(): boolean {
    return this.authConfigService.isCredentialsAuthMode();
  }

  showProfileLink() {
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'True') {
      return false;
    }
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'False') {
      return true;
    }
    if (this.authService.decodedToken.role === 'Super Admin' || this.authService.decodedToken.role === 'Site Admin') {
      return true;
    }
  }

  adminDropDownLink() {
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'True') {
      return false;
    }
    if (this.authService.decodedToken.role === 'Regular' && this.authService.decodedToken.isgeneric === 'False') {
      return false;
    }
    if (this.authService.decodedToken.role === 'Super Admin' || this.authService.decodedToken.role === 'Site Admin') {
      return true;
    }
  }

  adminLink() {
    if (this.authService.decodedToken.role === 'Super Admin' || this.authService.decodedToken.role === 'Site Admin') {
      return false;
    }
    return true;
  }

  openUserProfileModalWindow(id) {
    const dialogRef = this.dialog.open(UserProfileComponent, {
      width: '1000px',
      data: {
        user: id
      }
    });
  }

  openChangePasswordModalWindow(id) {
    const dialogRef = this.dialog.open(UserUpdatepasswordComponent, {
      width: '500px',
      data: {
        user: id
      }
    });
  }

  openLoginModalWindow() {
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '500px'
    });
  }

  logout() {
    this.authService.logout();
    this.alertify.message('Logged out Successfully');
    this.router.navigate(['/search']);
  }
}